import { render, staticRenderFns } from "./StoreName.vue?vue&type=template&id=848ba8c4&"
import script from "./StoreName.vue?vue&type=script&lang=js&"
export * from "./StoreName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports